const UserActivity = () => {
  return (
    <div className="mt-10">
      <span className="font-medium text-[16px]">Upcoming Events</span>
      <div className="mt-5 flex overflow-scroll connections gap-x-5">
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
      </div>
      <span className="font-medium text-[16px] mt-10 inline-block">
        Past Events
      </span>
      <div className="mt-5 flex overflow-scroll connections gap-x-5">
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
        <img
          src="/svgs/event.svg"
          alt="event"
          className="w-[200px] h-[130px] rounded-[10px]"
        />
      </div>
    </div>
  );
};

export default UserActivity;
